import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-links',
  templateUrl: './links.component.html',
  styleUrls: ['./links.component.css']
})
export class LinksComponent implements OnInit {
  html: any = '';

  constructor(public auth: AuthService, private atcivatedRoute: ActivatedRoute) {
    this.atcivatedRoute.params.subscribe(params => {
      if (params['type'] == 'CAREER') {
        this.getHtml('HELP');
      } else if (params['type'] == 'faq') {
        this.getHtml('DAKTARZ_PAGE_1');
      } else if (params['type'] == 'donate') {
        this.getHtml('DAKTARZ_PAGE_2');
      } else if (params['type'] == 'INFO') {
        this.getHtml('DAKTARZ_PAGE_3');
      } else {
        this.getHtml(params['type']);
      }
    });
  }

  ngOnInit() {
    // if(this.atcivatedRoute.snapshot.params.type)
    //   this.getHtml(this.atcivatedRoute.snapshot.params.type)
  }

  getHtml(type) {
    this.auth.getHtml(type).subscribe(res => {

      if (res["data"][0]) {
        this.html = res["data"][0].description;
      } else {
        this.html = ''
      }

      console.log(this.html, 'ssdsds')
    })
  }

}
